import { c as _c } from "react/compiler-runtime";
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { AddIcon } from '@systemeio/ui/icons';
interface ContactFilterAddButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
const ContactFilterAddButton = t0 => {
  const $ = _c(6);
  const {
    onClick
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AddIcon className="fill-green" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("dashboard.contacts.filter.add_condition");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClick || $[4] !== t2) {
    t3 = <button type="button" onClick={onClick} className="focus-visible:border-green border-text-secondary/30 text-green hover:border-green main-transition-colors relative flex min-h-[42px] items-center justify-center gap-2 rounded-lg border border-dashed px-4 py-2.5 text-sm font-medium outline-hidden">{t1}{t2}</button>;
    $[3] = onClick;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default ContactFilterAddButton;